import {
  SUPER_ADMIN,
  powerAdmin3Roles,
  powerAdmin4Roles,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";

export const getAllowedStatus = (applicationStatus, userRoles) => {
  const { approvedBy, rejectedBy } = applicationStatus;

  if (userRoles.includes(SUPER_ADMIN)) {
    return {
      canApproved: true,
      canRejected: true,
      canRevoked: false,
    };
  }

  if (isAuthorizedUser(userRoles, powerAdmin3Roles)) {
    return {
      canApproved: powerAdmin4Roles.includes(approvedBy),
      canRejected:
        powerAdmin4Roles.includes(approvedBy) ||
        powerAdmin4Roles.includes(rejectedBy),
      canRevoked: powerAdmin4Roles.includes(rejectedBy),
    };
  }

  if (isAuthorizedUser(userRoles, powerAdmin4Roles)) {
    return {
      canApproved: !approvedBy && !rejectedBy,
      canRejected: !approvedBy && !rejectedBy,
      canRevoked: false,
    };
  }

  return {
    canApproved: false,
    canRevoked: false,
    canRejected: false,
  };
};
